"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const styled_components_1 = __importDefault(require("styled-components"));

const SizedBox_1 = __importDefault(require("../sized-box/SizedBox"));

const Center_1 = __importDefault(require("../center/Center"));
/**
 * This component displays a box to represent where other widgets will one day
 * be added.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/Placeholder-class.html
 */


const Placeholder = _a => {
  var {
    shape = 'square',
    width = '100%',
    height = '100%',
    children = react_1.default.createElement(SizedBox_1.default, {
      width: "24px",
      height: "24px"
    })
  } = _a,
      props = __rest(_a, ["shape", "width", "height", "children"]);

  return react_1.default.createElement(SizedPlaceholder, Object.assign({
    shape: shape,
    width: width,
    height: height
  }, props), react_1.default.createElement(Center_1.default, null, children));
};

const SizedPlaceholder = styled_components_1.default(SizedBox_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: rgba(0, 0, 0, 0.02);\n  border: 2px dashed rgba(0, 0, 0, 0.1);\n  color: rgba(0, 0, 0, 0.1);\n  border-radius: ", ";\n  overflow: hidden;\n"])), props => {
  switch (props.shape) {
    case 'square':
      return '4px';

    case 'circle':
      return '50%';

    case 'stadium':
      return "min(".concat(props.width, ", ").concat(props.height, ")");
  }
});
exports.default = Placeholder;